import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import classNames from "classnames";
import {PageProps} from "gatsby";
import {Layout} from "../containers/Layout";
import {classes} from "../utils";
import {Button} from "primereact/button";
import {Link} from "../components/Link";
import {InputText} from "primereact/inputtext";
import {Checkbox} from "primereact/checkbox";
import {RadioButton} from "primereact/radiobutton";
import {Message} from "primereact/message";
import {URLs} from "../urls";


export default function Subscribe(props: PageProps) {
    // useEffect(() => {
    //     window.location.href = URLs.MAILCHIMP_FORM;
    // })
    return <Iframe src={URLs.MAILCHIMP_FORM}/>;
}

const Iframe = styled.iframe`
    height: 100vh;
    width: 100vw;
    border: none;
    outline: none;
`;

// export function OLDSubscribe(props: PageProps) {
//     const location = useLocation();
//     const tierHint = new URLSearchParams(location.search).get('tier');
//     const [iOS, setIOS] = useState(false);
//     const [android, setAndroid] = useState(false);
//     const [browsers, setBrowsers] = useState(false);
//     const [emailPerms, setEmailPerms] = useState(false);
//     const [tier, setTier] = useState<'free' | 'monthly' | 'yearly' | null>(['free', 'monthly', 'yearly'].includes(tierHint) ? tierHint as 'free' | 'monthly' | 'yearly' : null);
//     const [error, setError] = useState<String>(null);
//
//     const canSubmit = iOS || android || browsers;
//
//     return <>
//         <div id={"subscribe"} className={'w-0 h-0 opacity-0'}/>
//         <Layout {...props}>
//             <Container {...props} className={classNames('Subscribe flex flex-center mt-3 mb-8')}>
//                 <link href="//cdn-images.mailchimp.com/embedcode/classic-071822.css" rel="stylesheet" type="text/css"></link>
//                 <style type="text/css">{`
//             #mc_embed_signup{clear:left; font:14px Helvetica,Arial,sans-serif;  width:600px;}
//             /* Add your own Mailchimp form style overrides in your site stylesheet or in this style block.
//             We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */
//         `}</style>
//                 <style type="text/css">{`
//             #mc-embedded-subscribe-form input[type=checkbox]{display: inline; width: auto;margin-right: 10px;}
//             #mergeRow-gdpr {margin - top: 20px;}
//             #mergeRow-gdpr fieldset label {font - weight: normal;}
//             #mc-embedded-subscribe-form .mc_fieldset{border:none;min-height: 0px;padding-bottom:0px;}
//         `}</style>
//                 <div id="mc_embed_signup">
//                     <form action="https://mycopilot.us10.list-manage.com/subscribe/post?u=241faa8632901abf0f0fea122&amp;id=375c85b106&amp;v_id=5172&amp;f_id=000bd3e5f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
//                         <div id="mc_embed_signup_scroll">
//                             <h2 className={`${classes.text_1_4} text-center`}>Get Updated On The Next Downloadable Pilot Version</h2>
//                             {/*<p className='text-center'>Next scheduled pilot app test for Android:</p>*/}
//                             {/*<p className={'next-flight-date font-semibold mt-1 mb-4 text-primary text-center'}>{NextFlight}</p>*/}
//                             <div className="indicates-required"><span className="asterisk">*</span> indicates required</div>
//                             <div className="mc-field-group">
//                                 <label htmlFor="mce-EMAIL">Email Address <span className="asterisk">*</span>
//                                 </label>
//                                 <InputText type="email" name="EMAIL" className="required email" id="mce-EMAIL" required/>
//                                 {/*<span id="mce-EMAIL-HELPERTEXT" className="helper_text"></span>*/}
//                             </div>
//                             <div className="mc-field-group input-group">
//                                 <h3 className={'block mb-2'}>How do you pilot your internet? </h3>
//                                 <ul>
//                                     <li className={'mb-2'}>
//                                         <Checkbox className='mr-3' checked={android} onChange={e => setAndroid(e.checked)} value="1" name="group[496468][1]" id="mce-group[496468]-496468-0"/>
//                                         <label htmlFor="mce-group[496468]-496468-0">Android</label>
//                                     </li>
//                                     <li className={'mb-2'}>
//                                         <Checkbox className='mr-3' checked={iOS} onChange={e => setIOS(e.checked)} value="2" name="group[496468][2]" id="mce-group[496468]-496468-1"/>
//                                         <label htmlFor="mce-group[496468]-496468-1">iOS</label>
//                                     </li>
//                                     <li>
//                                         <Checkbox className='mr-3' checked={browsers} onChange={e => setBrowsers(e.checked)} value="4" name="group[496468][4]" id="mce-group[496468]-496468-2"/>
//                                         <label htmlFor="mce-group[496468]-496468-2">Desktop Browsers</label>
//                                     </li>
//                                 </ul>
//                                 {/*<span id="mce-group[496468]-HELPERTEXT" className="helper_text"></span>*/}
//                             </div>
//                             {!!tierHint && <div className="mc-field-group input-group">
//                                 <h3 className={'block mb-2'}>Plan Preference</h3>
//                                 <ul>
//                                     <li>
//                                         <RadioButton className='mr-3' checked={tier === 'free'} onChange={() => setTier('free')} value="Free Tier" name="SUBINTENT" id="mce-SUBINTENT-0"/>
//                                         <label htmlFor="mce-SUBINTENT-0">Free Tier</label>
//                                     </li>
//                                     <li>
//                                         <RadioButton className='mr-3' checked={tier === 'monthly'} onChange={() => setTier('monthly')} value="Monthly" name="SUBINTENT" id="mce-SUBINTENT-1"/>
//                                         <label htmlFor="mce-SUBINTENT-1">Monthly</label>
//                                     </li>
//                                     <li>
//                                         <RadioButton className='mr-3' checked={tier === 'yearly'} onChange={() => setTier('yearly')} value="Yearly" name="SUBINTENT" id="mce-SUBINTENT-2"/>
//                                         <label htmlFor="mce-SUBINTENT-2">Yearly</label>
//                                     </li>
//                                 </ul>
//                                 {/*<span id="mce-SUBINTENT-HELPERTEXT" className="helper_text"></span>*/}
//                             </div>}
//                             <div id="mergeRow-gdpr" className="mergeRow gdpr-mergeRow content__gdprBlock mc-field-group">
//                                 <div className="content__gdpr">
//                                     <label className={'text-lg mt-2 mb-1'}>Marketing Permissions</label>
//                                     <p>Please select all the ways you would like to hear from us:</p>
//                                     <fieldset className="mc_fieldset gdprRequired mc-field-group" name="interestgroup_field">
//                                         <label className="checkbox subfield" htmlFor="gdpr_60696">
//                                             <Checkbox className='av-checkbox mr-3' checked={emailPerms} onChange={e => setEmailPerms(e.checked)} id="gdpr_60696" name="gdpr[60696]" value="Y"/>
//                                             <span>Email</span>
//                                         </label>
//                                     </fieldset>
//                                     <p className={'text-xs mt-3 text-500'}>By submitting this form you can unsubscribe at any time by clicking the link in the footer of our emails. For information about our privacy practices, please visit our website.</p>
//                                 </div>
//                                 <div className="content__gdprLegal">
//                                     <p className={'text-xs mt-3 text-600'}>We use Mailchimp as our marketing platform. By clicking below to subscribe, you acknowledge that your information will be transferred to Mailchimp for processing. <Link to="https://mailchimp.com/legal/terms" className={'text-primary-700'}>Learn more about Mailchimp's privacy practices here.</Link></p>
//                                 </div>
//                             </div>
//                             <div id="mce-responses" className="clear">
//                                 <div className="response hidden" id="mce-error-response"></div>
//                                 <div className="response hidden" id="mce-success-response"></div>
//                             </div>
//                             <div style={{position: 'absolute', left: '-5000px'}} aria-hidden="true"><input type="text" name="b_241faa8632901abf0f0fea122_375c85b106" tabIndex={-1} value=""/></div>
//                             <div className="clear"><Button type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="" onSubmit={(event) => {
//                                 if (!canSubmit) {
//                                     setError('Please tell us how you access the internet so we can send you the correct information.');
//                                     event.preventDefault();
//                                 }
//                             }}>Join The Early Access List</Button></div>
//                         </div>
//                     </form>
//                 </div>
//                 <script type='text/javascript' src='//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'></script>
//                 <script type='text/javascript'>{`(function ($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';fnames[3]='ADDRESS';ftypes[3]='address';fnames[4]='PHONE';ftypes[4]='phone';}(jQuery));var $mcj = jQuery.noConflict(true);`}</script>
//             </Container>
//         </Layout>
//     </>;
// }
//
// const Container = styled.div``;
